import { render } from "./GroupItemView.vue?vue&type=template&id=9c80af56"
import script from "./GroupItemView.vue?vue&type=script&lang=js"
export * from "./GroupItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__